import { PAGE_IDS } from '@/constants/pages';
import { DashboardNavigationItem } from '@/types';
import { Page } from '@thoughtspot/visual-embed-sdk';

export const sparkRoute: DashboardNavigationItem = { label: 'Spark', pageId: PAGE_IDS.Spark };

export const thoughtSpotRoutes: DashboardNavigationItem[] = [
  { label: 'Overview', pageId: PAGE_IDS.Overview },
  { label: 'Dashboards', pageId: PAGE_IDS.Dashboards },
  { label: 'Charts', pageId: PAGE_IDS.Charts },
  { label: 'AI Highlights', pageId: PAGE_IDS.AIHighlights },
  {
    label: 'Alerts',
    pageId: PAGE_IDS.Alerts,
    subnav: [
      { label: 'Subscriptions', pageId: PAGE_IDS.Subscriptions },
      { label: 'Scheduled Dashboards', pageId: PAGE_IDS.Schedules },
    ],
  },
  {
    label: 'Data',
    pageId: PAGE_IDS.DataSource,
    preload: false,
    subnav: [
      { label: 'Datasets', pageId: PAGE_IDS.Datasets, preload: false },
      { label: 'Sources', pageId: PAGE_IDS.Sources, preload: false },
      { label: 'Question Labels', pageId: PAGE_IDS.QuestionLabels, preload: false },
    ],
  },
];

export const chatterMillRoutes: DashboardNavigationItem[] = [
  {
    label: 'Pulse',
    pageId: PAGE_IDS.Pulse,
  },
];

/**
 * Maps page IDs to ThoughtSpot pages
 * @type {Record<string, Page>}
 */
export const pageIdToThoughtSpotPage: Record<string, Page> = {
  [PAGE_IDS.Overview]: Page.Home,
  [PAGE_IDS.Dashboards]: Page.Liveboards,
  [PAGE_IDS.Charts]: Page.Answers,
  [PAGE_IDS.AIHighlights]: Page.SpotIQ,
  [PAGE_IDS.Alerts]: Page.Monitor,
  [PAGE_IDS.Subscriptions]: Page.Monitor,
  [PAGE_IDS.Data]: Page.Data,
};
